import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";

const WarningPopup = ({ dialogTitle = 'Confirm', open, handleClose, handleConfirm, details }) => {
  return (
    <Dialog
      open={open}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog"
      PaperProps={{
        style: {
          borderRadius: "10px",
          overflow: "hidden",
          bottom: "18%",
        },
      }}
    >
      <Box sx={{ width: "442px" }}>
        <DialogTitle className="diabtn-dark">{dialogTitle}</DialogTitle>
        <DialogContent style={{ padding: "40px 20px" }}>
          <DialogContentText id="primary-dialog">
            <p
              className="btntext"
              style={{
                textAlign: "center",
                color: "#000",
                fontSize: "18px",
                margin: 0,
              }}
            >
              {details.title}
            </p>
            {details?.title1 && (
              <p
                className="btntext"
                style={{
                  textAlign: "center",
                  color: "#000",
                  fontSize: "18px",
                  margin: 0,
                }}
              >
                {details.title1}
              </p>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{
            justifyContent: "center",
            gap: "15px",
          }}
          className={
              details.btnName === "Yes"
                ? "warning-actionbtns"
                : "alert-actionbtns"
            }
        >
          <Button onClick={handleClose} className="cancel-link-btn">
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            variant="outlined"
            className="delete-confirm-btn"
            size="medium"
          >
            {details.btnName}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default WarningPopup;
